import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { trackPhoneConversion } from '../../../utils/analytics';

export default function FinalCTA() {
  const { theme } = useTheme();
  const { ref: headRef, isVisible: headVisible } = useScrollAnimation({ threshold: 0.2 });
  const { ref: ctaRef, isVisible: ctaVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <section
      id="kontakt"
      className="relative py-14 sm:py-24 lg:py-32 px-4 overflow-hidden"
      style={{ fontFamily: theme.fonts.body }}
    >
      {/* Full-bleed background image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20breathtaking%20aerial%20view%20of%20the%20beautiful%20W%C3%BCrmtal%20valley%20in%20Bavaria%20Germany%20during%20golden%20hour%2C%20lush%20green%20rolling%20hills%20and%20forests%2C%20charming%20small%20towns%20and%20villages%20visible%20below%2C%20warm%20golden%20sunset%20light%20casting%20long%20shadows%2C%20idyllic%20Bavarian%20landscape%20with%20church%20steeples%20and%20traditional%20architecture%2C%20peaceful%20and%20inspiring%20atmosphere%2C%20professional%20landscape%20photography%2C%20rich%20warm%20tones%20of%20orange%20gold%20and%20deep%20green%2C%20wide%20panoramic%20view%20showing%20the%20entire%20valley&width=1920&height=800&seq=cta-bg-wuermtal-v3&orientation=landscape"
          alt="Würmtal Bayern"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/55"></div>
      </div>

      {/* Accent glow */}
      <div
        className="absolute top-0 right-0 w-[700px] h-[700px] rounded-full opacity-20 blur-3xl z-0"
        style={{ background: `radial-gradient(circle, ${theme.colors.accent} 0%, transparent 70%)` }}
      />
      <div
        className="absolute bottom-0 left-0 w-[500px] h-[500px] rounded-full opacity-10 blur-3xl z-0"
        style={{ background: `radial-gradient(circle, ${theme.colors.secondary} 0%, transparent 70%)` }}
      />

      <div className="max-w-4xl mx-auto relative z-10 text-center">

        {/* Headline */}
        <div
          ref={headRef}
          style={{
            opacity: headVisible ? 1 : 0,
            transform: headVisible ? 'translateY(0)' : 'translateY(40px)',
            transition: 'opacity 0.8s ease, transform 0.8s ease',
          }}
        >
          <h2
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black mb-5 text-white leading-[1.05]"
            style={{ fontFamily: theme.fonts.heading }}
          >
            Lassen Sie uns<br />
            <span style={{
              background: `linear-gradient(135deg, #fff 0%, ${theme.colors.accent} 100%)`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}>
              Ihre Website schmieden.
            </span>
          </h2>

          <p className="text-base md:text-lg md:text-xl mb-4 text-white/80 max-w-xl mx-auto leading-relaxed">
            Kostenloses Erstgespräch.<br />
            Persönlich aus dem Würmtal.
          </p>
        </div>

        {/* CTA Buttons */}
        <div
          ref={ctaRef}
          className="flex flex-col sm:flex-row gap-3 justify-center mt-8 mb-10 md:mb-16"
          style={{
            opacity: ctaVisible ? 1 : 0,
            transform: ctaVisible ? 'translateY(0) scale(1)' : 'translateY(30px) scale(0.95)',
            transition: 'opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s',
          }}
        >
          <a href="tel:+491607676763" className="w-full sm:w-auto" onClick={(e) => { e.preventDefault(); trackPhoneConversion('tel:+491607676763'); }}>
            <button
              className="w-full sm:w-auto px-8 md:px-12 py-4 md:py-5 font-bold text-base rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl whitespace-nowrap cursor-pointer"
              style={{
                background: `linear-gradient(135deg, ${theme.colors.secondary} 0%, ${theme.colors.accent} 100%)`,
                color: '#FFFFFF',
                boxShadow: `0 10px 40px ${theme.colors.accent}60`,
              }}
            >
              <span className="flex items-center gap-2 justify-center">
                <i className="ri-phone-line text-base"></i>
                Jetzt anrufen
              </span>
            </button>
          </a>
          <Link to="/termin-buchen" className="w-full sm:w-auto">
            <button
              className="w-full sm:w-auto px-8 md:px-12 py-4 md:py-5 font-semibold text-base rounded-xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              style={{
                backgroundColor: 'rgba(255,255,255,0.1)',
                color: '#FFFFFF',
                border: '2px solid rgba(255,255,255,0.3)',
                backdropFilter: 'blur(8px)',
              }}
            >
              Online-Termin vereinbaren
            </button>
          </Link>
          <Link to="/termin-buchen#lieber-schreiben" className="w-full sm:w-auto">
            <button
              className="w-full sm:w-auto px-8 md:px-12 py-4 md:py-5 font-semibold text-base rounded-xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              style={{
                backgroundColor: 'rgba(255,255,255,0.1)',
                color: '#FFFFFF',
                border: '2px solid rgba(255,255,255,0.3)',
                backdropFilter: 'blur(8px)',
              }}
            >
              Nachricht senden
            </button>
          </Link>
        </div>

      </div>
    </section>
  );
}